import {FileMessage, FileMessages} from "../../../openapi/generated-clients/climatecompass";

export default class GenericTableComponentClass {
  calculationId?: number
  calculateId?: number
  readonly?: boolean
  remarksFieldValue?: string
  remarksFieldLabel?: string
  scope3CategoryLabel?: string
  scope3CategorySelection?: string
  rowColData?: (string | number | undefined)[][]
  rowColHeaders?: (string | undefined)[][]
  fieldValues?: any[]
  isEdit?: boolean
  createdBy?: string
  createdTime?: string
  updatedBy?: string
  updatedTime?: string
  state?: string
  emcId?: number
  emf?: string
  information?: string
  files?: FileMessages | undefined
  showWarning?: boolean
}
